import type { OffPisteElevationBand } from "./offpiste-scoring-v5";
import type { TouringElevationBand } from "./ski-touring-scoring-v4";

type TierKey = "Base" | "Mid" | "Summit";
type TierScore = { score: number; label: string };

/** Map the active sport's elevation bands onto the Base/Mid/Summit tiers.
 *  Display tiers may be based on a different weather fetch elevation than the
 *  scored band anchors, so joins use band identity instead of exact elevation.
 *  Piste/mtb/other return nulls so the panel shows no column. */
export function elevationBandColumn(
  activeSport: string,
  offPiste: OffPisteElevationBand[] | null,
  touring: TouringElevationBand[] | null,
  tiers: { label: TierKey; elevationM: number }[],
): { sportLabel: string | null; tierScores: Record<TierKey, TierScore> | null } {
  if (activeSport === "off-piste" && offPiste && offPiste.length > 0) {
    const out: Partial<Record<TierKey, TierScore>> = {};
    for (const t of tiers) {
      const band = t.label.toLowerCase();
      const b = offPiste.find((x) => x.band === band);
      if (b) out[t.label] = { score: b.score, label: b.label };
    }
    return {
      sportLabel: "Off-piste",
      tierScores: Object.keys(out).length ? (out as Record<TierKey, TierScore>) : null,
    };
  }
  if (activeSport === "touring" && touring && touring.length > 0) {
    const out: Partial<Record<TierKey, TierScore>> = {};
    for (const t of tiers) {
      const targetBand = t.label === "Summit" ? "upper" : "lower";
      const z = touring.find((x) => x.band === targetBand);
      if (z) out[t.label] = { score: z.score, label: z.label };
    }
    return {
      sportLabel: "Touring",
      tierScores: Object.keys(out).length ? (out as Record<TierKey, TierScore>) : null,
    };
  }
  return { sportLabel: null, tierScores: null };
}
